// extracted by mini-css-extract-plugin
export default {"switchDiv":"switch_switchDiv__ji4GI","switchBtn":"switch_switchBtn__DFUiI"};